import { makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => ({
  dropdownTopSection: {
    "& > div:first-child": {
      alignItems: "flex-end",
      justifyContent: "space-between",
      "& > *:last-child": {
        padding: 0,
      },
    },
  },
  fillerItem: {
    padding: 0,
  },
  container: {
    "& > div": {
      top: 0,
    },
  },
  sectionMargin: {
    marginTop: theme.hv.spacing.md,
    outline: "none",
  },
  loading: {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
  },
  zIndex: {
    // We need to set this nonsense value to make sure the loading overlays all HVS page elements.
    zIndex: 9999999999,
  },
  title: {
    ...theme.hv.typography.xsTitle,
  },
  formHeaderIcon: {
    height: 32,
    width: 32,
    marginRight: theme.hv.spacing.xs,
    padding: "8px 6px",
    fontSize: 17,
    textAlign: "center",
  },
}));

export default styles;
